import Menu from '@netx/core/lib/netx-menu';

export default {
	/**
	 * Default CMS menu for a portal that has no menus stored on the server yet:
	 */
	defaultCMSMenu: new Menu({
		label: i18n.t('i18n.mainMenu'),
		name: 'main',
		actions: ['app:logout'],
	}),
};
